import React, {useContext, useState} from 'react';
import './ZipEdit.less';
import {DrawerPopup} from "dialog-layout/drawer-popup/DrawerPopup.tsx";
import {Button} from "elements/button/Button";
import {Error} from 'elements/error/Error';
import {Input} from 'elements/input/Input';
import {TranslationsContext} from "contexts/translations-context";
import {getSafeTranslation} from "helpers/localization.helper.ts";

export const ZIP_EDIT_POPUP = 'ZIP_EDIT_POPUP';
export const CART_ZIP_EDIT_POPUP = 'CART_ZIP_EDIT_POPUP';

export const ZipEdit = ({error, onCancelClick, onDoneClick, onOverlayClick}) => {
	const [zip, setZip] = useState('');

	const translations = useContext(TranslationsContext);

	return <DrawerPopup
		title={getSafeTranslation('ZipEditPopup.title', translations)}
		description={getSafeTranslation('ZipEditPopup.description', translations)}
		onOverlayClick={onOverlayClick}
		leftControl={<Button isText onClick={onCancelClick}>{
			getSafeTranslation('ZipEditPopup.cancelButtonCaption', translations)
		}</Button>}
		rightControl={<Button isAutoWidth onClick={() => onDoneClick(zip)} isDisabled={zip.length <= 0}>{
			getSafeTranslation('ZipEditPopup.doneButtonCaption', translations)
		}</Button>}
	>
		<div className="zip-edit">
			<div className="zip-edit__input">
				<Input value={zip} onChange={setZip} regex={/^\d*$/} focusOnMount/>
			</div>
			{
				<div className="zip-edit__error">
					<Error text={error}/>
				</div>
			}
		</div>
	</DrawerPopup>
}
